import React from 'react';

import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.js';

/**
 * Skeleton component for SearchResults.
 * Matches the dimensions and layout of the SearchResults component.
 */
export const SearchResultsSkeleton: React.FC<{
  itemCount?: number;
}> = ({ itemCount = 9 }) => {
  return (
    <section className="SearchResults component">
      <div className="SearchResults__container container">
        {/* Search results list skeleton */}
        <div className="flex flex-col gap-comfy-xl">
          {/* Results count skeleton */}
          <Skeleton height={20} width={200} />

          {/* Results list skeleton */}
          <div className="flex flex-col gap-comfy-xl">
            {Array.from({ length: itemCount }, (_, index) => (
              <div key={index} className="flex-1 flex flex-col gap-snug-sm">
                {/* Content skeleton */}
                <Skeleton height={24} width="80%" />
                <Skeleton height={16} width="100%" />
                <Skeleton height={16} width="90%" />
              </div>
            ))}
          </div>

          {/* Pagination skeleton */}
          <div className="flex justify-center mt-comfy-lg">
            <div className="flex gap-snug-sm">
              <Skeleton height={48} width={48} borderRadius="0.5rem" />
              <Skeleton height={48} width={48} borderRadius="0.5rem" />
              <Skeleton height={48} width={48} borderRadius="0.5rem" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
